import _ from 'lodash';
import React, {Component} from 'react';
import { connect } from 'react-redux';
import {checkTicketDaschoardStatus} from 'TicketAction';
import {checkEventTemplate} from 'TemplatesAction';
import { fetchFeature, checkContentDashboardStatus } from 'GeneralTabAction';
import {fetchEventDetails} from 'DashboardUserAction';
import {updateEventPublish} from 'CheckoutAction';
import LocaleStrings from 'Languages';

class AdminPanelDashboardStatus extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.checkTicketDaschoardStatus(this.props.session);
        this.props.checkEventTemplate(this.props.session);
        this.props.fetchFeature(this.props.session);
        this.props.checkContentDashboardStatus(this.props.session);
        this.props.fetchEventDetails(this.props.session);
    }

    redirectUrl = (e) => {
        let step = e.currentTarget.dataset.data_id;
        if(step == 'Step1') {
            var path='managetickets';
            this.props.history.push(`/dashboard/tickets/${path}`);
        }
        else if(step == 'Step2') {
            var path='payout';
            this.props.history.push(`/dashboard/tickets/${path}`);
        }
        else if(step == 'Step3') {
            var path='settings';
            this.props.history.push(`/dashboard/tickets/${path}`);
        }        
        else if(step == 'Step4') {
            var path='themes';
            this.props.history.push(`/dashboard/website/${path}`);
        }        
        else if(step == 'Step5') {
            var path='settings';
            this.props.history.push(`/dashboard/website/${path}`);
        }        
        else if(step == 'Step6') {
            var path='content';
            this.props.history.push(`/dashboard/${path}`);
        }        
    }

    chnagePublishApp = () => {
        let {eventDetails, session} = this.props;

        let status = 1;
        let id = eventDetails.eventid;
        if(eventDetails &&  eventDetails.published){
            status = 0;
        }

        this.props.updateEventPublish(session, status, id, (response) => {
            if(response.success) {
                this.props.fetchEventDetails(session);
            }
        });
    }

    /**
     * =============================================================================================
     */

    render() {
        let {ticketDashboard, eventSelectedTemplate, availableFeatures, contentDashboard, eventDetails, actionAppModules} = this.props;

        let ticketValidationStyle='steps-icon-not-filled';
        let stripeValidationStyle='steps-icon-not-filled';
        let settingValidationStyle='steps-icon-not-filled';

        let ticketIcon='fa fa-exclamation-circle';
        let stripeIcon='fa fa-exclamation-circle';
        let settingIcon='fa fa-exclamation-circle';
        
        if(ticketDashboard && ticketDashboard.ticket) {
            ticketValidationStyle = 'steps-icon-filled';
            ticketIcon='fa fa-check-circle';
        }
        if(ticketDashboard && ticketDashboard.paymentgateway) {
            stripeValidationStyle = 'steps-icon-filled';
            stripeIcon = 'fa fa-check-circle';
        }
        if(ticketDashboard && ticketDashboard.setting) {
            settingValidationStyle = 'steps-icon-filled';
            settingIcon = 'fa fa-check-circle';
        }

        let templateValidationStyle='steps-icon-not-filled';
        let tempSettingValidationStyle='steps-icon-not-filled';        

        let templateIcon='fa fa-exclamation-circle';
        let tempSettingIcon='fa fa-exclamation-circle';
        let template = false;
        let tempsetting = false;
        
        if(eventSelectedTemplate && eventSelectedTemplate.length>0 ) {
            templateValidationStyle = 'steps-icon-filled';
            templateIcon='fa fa-check-circle';
            template = true;
        }

        if(eventSelectedTemplate && eventSelectedTemplate.length>0 && eventSelectedTemplate[0].website_subdomain != '' && eventSelectedTemplate[0].website_url != '') {
            tempSettingValidationStyle = 'steps-icon-filled';
            tempSettingIcon = 'fa fa-check-circle';
            tempsetting = true;
        }

        let contentValidationStyle='steps-icon-not-filled'; 
        let contentIcon='fa fa-exclamation-circle';
        let content = true;
        _.map(availableFeatures, feature => {
            if(feature.isenabled) {
                if(contentDashboard && !contentDashboard[feature.bsClass]) {
                    content = false;
                }
            }
        });

        if(content) {
            contentValidationStyle = 'steps-icon-filled';
            contentIcon = 'fa fa-check-circle';
        }        

        let checked = false;
        if(eventDetails){
            checked = eventDetails.published;
        }

        let ticketShow = [];
        let websiteShow = [];
        if(actionAppModules && actionAppModules.length > 0) {
            ticketShow = _.filter(actionAppModules, (app) => {return app.iconName == "tickets"});
            websiteShow = _.filter(actionAppModules, (app) => {return app.iconName == "website"});
        }

        let publish = false;
        if(ticketShow.length>0 && ticketShow[0].isenabled && websiteShow.length>0 && websiteShow[0].isenabled) {
            if(ticketDashboard && ticketDashboard.ticket && ticketDashboard.setting && ticketDashboard.paymentgateway && template && tempsetting && content) {
                publish = true;
            }
        }
        else if(ticketShow.length>0 && ticketShow[0].isenabled && websiteShow.length>0 && !websiteShow[0].isenabled) {
            if(ticketDashboard && ticketDashboard.ticket && ticketDashboard.setting && ticketDashboard.paymentgateway && content) {
                publish = true;
            }
        }
        else if(ticketShow.length>0 && !ticketShow[0].isenabled && websiteShow.length>0 && websiteShow[0].isenabled) {
            if(template && tempsetting && content) {
                publish = true;
            }
        }
        else {
            if(content) {
                publish = true;
            }
        }
        
        return (
            <div className="row ticket-dashboard" >
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    {/* {publish ? 
                        <div className="ticket-dashboard-ticket-sell-main-div">
                            <div className="sell-text">Publish App</div>
                            <div className="sell-action">
                                <label className="ticket-sell-switch">
                                    <input type="checkbox" onChange={this.chnagePublishApp} checked={checked} />
                                    <span className="ticket-sell-slider ticket-sell-round"></span>
                                </label>
                            </div>
                        </div>
                    : 
                        null
                    } */}

                    <div style={{fontSize: 14, marginTop:10, marginBottom: 10}}>{LocaleStrings.publish_event_dashboard_text_things_to_do}</div>
                    <div className="ticket-dashboard-steps-main-div">
                        {ticketShow.length > 0 && ticketShow[0].isenabled ?
                            <div>
                            <div className="dashboard-steps" data-data_id="Step1" onClick={this.redirectUrl}>
                                <div className={ticketValidationStyle}><i className={ticketIcon} aria-hidden="true"></i></div>
                                <div style={{width: '88%'}}>
                                    <h4 className="heading-para">{LocaleStrings.tickets_dashboard_text_add_a_ticket}</h4>
                                    <p className="description-para">{LocaleStrings.tickets_dashboard_text_add_a_ticket_sub_title}</p>
                                </div>
                                <div className="steps-icon-arrow"><i className="fa fa-chevron-circle-right" aria-hidden="false"></i></div>
                            </div>                        
                            <div className="dashboard-steps" data-data_id="Step2" onClick={this.redirectUrl}>
                                <div className={stripeValidationStyle}><i className={stripeIcon} aria-hidden="true"></i></div>
                                <div style={{width: '88%'}}>
                                    <h4 className="heading-para">{LocaleStrings.tickets_dashboard_text_connect_with_stripe}</h4>
                                    <p className="description-para">{LocaleStrings.tickets_dashboard_text_connect_with_stripe_sub_title}</p>
                                </div>
                                <div className="steps-icon-arrow"><i className="fa fa-chevron-circle-right" aria-hidden="false"></i></div>
                            </div>
                            <div className="dashboard-steps" data-data_id="Step3" onClick={this.redirectUrl}>
                                <div className={settingValidationStyle}><i className={settingIcon} aria-hidden="true"></i></div>
                                <div style={{width: '88%'}}>
                                    <h4 className="heading-para">{LocaleStrings.tickets_dashboard_text_complete_setting}</h4>
                                    <p className="description-para">{LocaleStrings.tickets_dashboard_text_complete_setting_sub_title}</p>
                                </div>
                                <div className="steps-icon-arrow"><i className="fa fa-chevron-circle-right" aria-hidden="false"></i></div>
                            </div>
                            </div>
                        :
                            ""
                        }
                       
                       {websiteShow.length > 0 && websiteShow[0].isenabled ?
                            <div>
                            <div className="dashboard-steps" data-data_id="Step4" onClick={this.redirectUrl}>
                                <div className={templateValidationStyle}><i className={templateIcon} aria-hidden="true"></i></div>
                                <div style={{width: '88%'}}>
                                    <h4 className="heading-para">{LocaleStrings.website_dashboard_text_things_to_do_1}</h4>
                                    <p className="description-para">{LocaleStrings.website_dashboard_text_things_to_do_1_sub_title}</p>
                                </div>
                                <div className="steps-icon-arrow"><i className="fa fa-chevron-circle-right" aria-hidden="false"></i></div>
                            </div>                        
                            <div className="dashboard-steps" data-data_id="Step5" onClick={this.redirectUrl}>
                                <div className={tempSettingValidationStyle}><i className={tempSettingIcon} aria-hidden="true"></i></div>
                                <div style={{width: '88%'}}>
                                    <h4 className="heading-para">{LocaleStrings.website_dashboard_text_things_to_do_2}</h4>
                                    <p className="description-para">{LocaleStrings.website_dashboard_text_things_to_do_2_sub_title}</p>
                                </div>
                                <div className="steps-icon-arrow"><i className="fa fa-chevron-circle-right" aria-hidden="false"></i></div>
                            </div>
                            </div>
                        :
                            ""
                        }

                        <div className="dashboard-steps" data-data_id="Step6" onClick={this.redirectUrl}>
                            <div className={contentValidationStyle}><i className={contentIcon} aria-hidden="true"></i></div>
                            <div style={{width: '88%'}}>
                                <h4 className="heading-para">{LocaleStrings.features_text_contents}</h4>
                                <p className="description-para">{LocaleStrings.publish_event_dashboard_text_content_sub_title}</p>
                            </div>
                            <div className="steps-icon-arrow"><i className="fa fa-chevron-circle-right" aria-hidden="false"></i></div>
                        </div>  
                    
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {

    return {
        // session: state.session,
        ticketDashboard: state.ticketDashboard.data,
        eventSelectedTemplate: state.eventSelectedTemplate,
        availableFeatures:state.availableFeatures.filter( (feature) => feature.available ),
        contentDashboard: state.contentDashboard.data,
        eventDetails: state.userEventDetails,
        actionAppModules: state.actionAppModules,
    };
}

export default connect(mapStateToProps, {checkTicketDaschoardStatus, checkEventTemplate, fetchFeature, checkContentDashboardStatus, fetchEventDetails, updateEventPublish})(AdminPanelDashboardStatus);
